/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface PlatformApiDBI
 */
export class PlatformApiDBI {
    /**
     *
     * @type {{ [key: string]: boolean; }}
     * @memberof PlatformApiDBI
     */
    REACT_APP_WT_FEATURES_FLAGS: { [key: string]: boolean };
    /**
     *
     * @type {string}
     * @memberof PlatformApiDBI
     */
    REACT_APP_MIX_PANEL_KEY?: string;
    /**
     *
     * @type {string}
     * @memberof PlatformApiDBI
     */
    REACT_APP_WT_CHAT_BASE_KEY?: string;
    /**
     *
     * @type {string}
     * @memberof PlatformApiDBI
     */
    REACT_APP_LUCKY_ORANGE_SRC?: string;
    /**
     *
     * @type {string}
     * @memberof PlatformApiDBI
     */
    REACT_APP_LUCKY_ORANGE_SITEID?: string;
    /**
     *
     * @type {string}
     * @memberof PlatformApiDBI
     */
    REACT_APP_LANDING_PAGE?: string;
    /**
     *
     * @type {string}
     * @memberof PlatformApiDBI
     */
    REACT_APP_WT_EXTERNAL_CZ_URL?: string;
    /**
     *
     * @type {string}
     * @memberof PlatformApiDBI
     */
    REACT_APP_WT_LOGROCKET_ID?: string;
    /**
     *
     * @type {string}
     * @memberof PlatformApiDBI
     */
    REACT_APP_GTM_CONTAINER_ID?: string;
    /**
     *
     * @type {string}
     * @memberof PlatformApiDBI
     */
    REACT_APP_WT_HEAD_SCRIPT?: string;
    /**
     *
     * @type {string}
     * @memberof PlatformApiDBI
     */
    REACT_APP_WT_BODY_OPEN_SCRIPT?: string;
    /**
     *
     * @type {string}
     * @memberof PlatformApiDBI
     */
    REACT_APP_WT_BODY_CLOSE_SCRIPT?: string;
}
